export default __webpack_public_path__ + "static/ay-support-content-bug-fixes-a995f6b7bb79873d415574a6a7d4b24e.svg";